import classNames from 'classnames';

import {gettext} from 'topmeteo/utils/i18n';

const Title = gettext('Settings');

const MobileLoopButton = ({hidden, onClick}) => (
    <div className={classNames('mobile-only', 'loop-button', {hidden})} onClick={onClick}>
        <i className="icon icon-loop-alt" title={Title} />
    </div>
);

export default MobileLoopButton;
